import "ngstorage";

import {WALKTHROUGH_STATES, TRIGGER_NEXT_EVENT_NAME, UPDATE_WORKFLOW_EVENT_NAME} from "../../variables";

class PayrateController {
  constructor(
    $localStorage,
    $rootScope,
    $scope,
    $state,
    $stateParams,
    AuthService,
    EnvService,
    SecurityService,
    $timeout,
    $location,
    TrackingService,
    events,
    companies
  ) {
    this.name = "payrate";
    this.walkthroughState = WALKTHROUGH_STATES.PAY;

    this.$localStorage = $localStorage;
    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.$state = $state;
    this.$location = $location;
    this.$stateParams = $stateParams;
    this.$auth = AuthService;
    this.$env = EnvService;
    this.$security = SecurityService;
    this.$timeout = $timeout;
    this.$tracking = TrackingService;
    this.$events = events;
    this.$companies = companies;
    this.calculatingCostsForFirstTime = 0;

    this.API_FIELDS = "isLongTerm,weeks,subEvents.deduppedJobbles.id,subEvents.deduppedJobbles.payPerHour,subEvents.deduppedJobbles.jobblePoolId";

    this.rate = 15;

    this.PostAJobSaveAndExitListener = this.$rootScope.$on("PostAJobSaveAndExit", ($event, params) => {
      this.savePay();
    });

    this.WorkflowUpdateListener = this.$rootScope.$on(UPDATE_WORKFLOW_EVENT_NAME, ($event, params) => {
      if (params && params.from_pay) return;
      this.savePay();
    });

    this.$scope.$on("$destroy", this.PostAJobSaveAndExitListener);
    this.$scope.$on("$destroy", this.WorkflowUpdateListener);
  }

  $onInit() {

    this.setLoader();
    /*
    this.$timeout(() => {
      if (!this.event.hourly_rate) {
        this.event.hourly_rate = 20;
      }
    });
    */

    this.$timeout(() => {
      /*
      if (!this.event.hourly_rate) {
        this.event.hourly_rate = 20;
      }
       */

      console.log("payrate - onInit");
      console.dir(this.event);

      const complete = this.$auth.hasCompletedPaymentInformation();

      this.calculateCosts("input");
      const currentUser = this.$auth.getUserData();

      const rate = currentUser.company.defaultPlan.companyFeePct;
      const autoAccept = currentUser.company.autoAccept;
      const autoManage = currentUser.company.autoManage;

      this.$timeout(() => {
        this.rate = rate;
        this.autoAccept = autoAccept;
        this.autoManage = autoManage;
      });

      this.syncWithApi();
      this.loadTeams();
    }, 1000);
  }

  $onChanges() {
    this.calculateCosts();
  }

  syncWithApi() {
    this.disableAllowedLinks();

    if (this.$location.$$search.cid) {
      this.$location.search("cid", null);
      this.$state.transitionTo("postashiftwalkthrough", {eid: this.event.id}, {notify: false});
      this.$rootScope.$emit("SendToDateTime", {});
    }

    this.$events.getEventByIdWithFields(this.event.id, this.API_FIELDS).then((data) => {
      this.jobble_id = data.data.subEvents[0].deduppedJobbles[0].id;
      this.jobble_pool_id = data.data.subEvents[0].deduppedJobbles[0].jobblePoolId;

      console.log("syncWithApi paycontroller", data.data);

      this.event.is_long_term = data.data.isLongTerm;
      this.event.numberOfWeeksToScheduleJob = data.data.weeks + "";

      const currentUser = this.$auth.getUserData();
      const rate = currentUser.company.defaultPlan.companyFeePct;
      let payPerHour = data.data.subEvents[0].deduppedJobbles[0].payPerHour;

      const epi = 0.00001;

      let p = 100 - rate * 100;
      payPerHour = (payPerHour * p) / 100 / 100;

      if (!this.$location.$$search.eid) {
        this.event.hourly_rate = Math.round((payPerHour + epi) * 100) / 100;
      }

      if (!this.event.hourly_rate) {
        this.event.hourly_rate = 20;
      }

      this.calculateCosts();
      this.validate();
      this.enableAllowedLinks();

      this.$timeout(() => {
        this.unSetLoader();
      }, 300);

    });
  }

  enableAllowedLinks() {
    console.log("enableAllowedLinks - pay rate");
    console.dir(this.allowed);
  }

  disableAllowedLinks() {
    console.log("disableAllowedLinks - pay rate");
    console.dir(this.allowed);
    //allowed {"openings":true,"position_type":true,"location":true,"shifts":-71.05228,"shift_title":true,"company_info":true,"shift_description":true,"arrival_instructions":true,"dress_code":true,"requirements":true,"hiring_manager":true,"hourly_rate":true}
  }

  savePay() {
    this.$timeout(() => {
      this.$rootScope.$emit("LockLeftPanel", {});
    });

    this.setLoader();

    return new Promise((resolve) => {
      const currentUser = this.$auth.getUserData();
      const rate = currentUser.company.defaultPlan.companyFeePct;
      const epi = 0.00001;

      let cost = parseFloat(this.event.hourly_rate);

      if (cost < 12) {
        console.warn("pay rate is too low");
      }

      let costPlusMarkUp = Math.round(cost * (1 + rate));

      if (!this.jobble_id) return resolve();

      this.$timeout(() => {
        this.$events.saveEventPayRate(this.jobble_id, cost).then((data) => {
          console.log("Saved pay:", data);
          this.$rootScope.$emit("UnLockLeftPanel", {});
          this.unSetLoader();
          resolve();
        });
      }, 1000);
    });
  }

  goNext() {
    console.log("job post jobble id", this.jobble_id);

    if (!this.jobble_id) {
      alert("There was an error saving your data. Please refresh the page to reload the job.");
      return;
    }

    let user = this.$auth.getUserData();

    let invoiceCustomer = null;

    if ((user.company.enableSubscription === true && user.company.sendInvoice === true) || user.company.payByInvoice === true) {
      invoiceCustomer = true;
    } else {
      invoiceCustomer = false;
    }

    const completedPaymentInformation = this.$auth.hasCompletedPaymentInformation();

    this.triggerLoadingModal();

    if (!completedPaymentInformation.completed && invoiceCustomer === false) {
      this.$timeout(() => {
        this.savingStep = true;
        this.setLoader();
      });

      let team_ids = this.event.cloudsForJobblePost;
      console.log("Exclusive team IDs:", team_ids);

      this.savePay()
        .then(() => {
          this.$tracking.reportPostAJobSubmitStep("pay rate");
          this.$timeout(() => {
            this.$events
              .publishEvent(this.jobble_id, true)
              .then((data) => {
                this.$timeout(() => {
                  this.savingStep = false;
                });

                this.setAutomationForJob();

              })
              .catch((err) => {
                this.$timeout(() => {
                  this.savingStep = false;
                  this.closeLoadingModal();
                });

                console.error(err);

                alert("There was an error publishing your job while attempting to publish the job.\n\nError:\n" + JSON.stringify(err, null, 2));
              });
          }, 2000);
        })
        .catch((err) => {
          this.$timeout(() => {
            this.savingStep = false;
            this.closeLoadingModal();
          });
          console.error(err);
          alert("There was an error publishing your job while attempting to save the pay rate.\n\nError:\n" + JSON.stringify(err, null, 2));
        });
    } else {
      this.$timeout(() => {
        this.savingStep = true;
        this.setLoader();
      });

      let team_ids = this.event.cloudsForJobblePost;
      console.log("Exclusive team IDs:", team_ids);

      this.savePay()
        .then(() => {
          this.$tracking.reportPostAJobSubmitStep("pay rate");

          if (team_ids && team_ids.length) {
            this.$timeout(() => {
              this.$events
                .pushTeamsOntoEvent(this.event.id, team_ids, null, true)
                .then((response) => {
                  console.log("pushTeamsOntoEvent resp");
                  console.dir(response);
                  this.$timeout(() => {
                    this.$events
                      .publishEvent(this.jobble_id, true)
                      .then((data) => {
                        console.log("Published exclusive event:", data);
                        this.$tracking.reportPostAJobSubmitStep("publish job");
                        this.$tracking.reportPostAJobSubmitStep("publish exclusive job");
                        this.$timeout(() => {
                          this.setAutomationForJob();
                        }, 1500);
                      })
                      .catch((err) => {
                        this.$timeout(() => {
                          this.savingStep = false;
                          this.closeLoadingModal();
                        });
                        console.error(err);
                        alert(
                          "There was an error publishing your job while attempting to publish the job.\n\nError:\n" + JSON.stringify(err, null, 2)
                        );
                      });
                  }, 3000);
                })
                .catch((err) => {
                  this.$timeout(() => {
                    this.savingStep = false;
                    this.closeLoadingModal();
                  });
                  console.error(err);
                  alert("There was an error publishing your job while attempting to add the team.\n\nError:\n" + JSON.stringify(err, null, 2));
                });
            }, 1500);
          } else {
            this.$timeout(() => {
            this.$events
              .publishEvent(this.jobble_id, true)
              .then((data) => {
                this.$tracking.reportPostAJobSubmitStep("publish job");
                console.log("Published event:", data);

                this.$tracking.reportPostAJobSubmitStep("publish public job");

                if (this.event.is_long_term && this.event.numberOfWeeksToScheduleJob && parseFloat(this.event.numberOfWeeksToScheduleJob) > 0) {
                  //this.setScheduleForJob();
                }

                this.$timeout(() => {
                  //this.savingStep = false;
                  this.setAutomationForJob();
                }, 1500);
              })
              .catch((err) => {
                this.$timeout(() => {
                  this.savingStep = false;
                  this.closeLoadingModal();
                });
                console.error(err);
                alert("There was an error publishing your job while attempting to publish the job.\n\nError:\n" + JSON.stringify(err, null, 2));
              });
            }, 2000);
          }
        })
        .catch((err) => {
          this.$timeout(() => {
            this.savingStep = false;
            this.closeLoadingModal();
          });
          console.error(err);
          alert("There was an error publishing your job while attempting to save the pay rate.\n\nError:\n" + JSON.stringify(err, null, 2));
        });
    }
  }

  closeLoadingModal() {
    console.log("closeLoadingModal");
    this.$timeout(() => {
      $("#job-creation-loader").modal("toggle");
    });
  }

  triggerLoadingModal() {
    console.log("triggerLoadingModal");
    this.$timeout(() => {
      $("#job-creation-loader").modal();
    });
  }

  setSchedule() {
    if (this.event.is_long_term && this.event.numberOfWeeksToScheduleJob && parseFloat(this.event.numberOfWeeksToScheduleJob) > 0) {
      this.setScheduleForJob();
    } else {
      this.$timeout(() => {
        this.closeLoadingModal();
      }, 3500);

      this.$timeout(() => {
        this.$state.go("jobsdashboard");
      }, 4000);
      return;
    }
  }

  setScheduleForJob() {
    let weeks = this.event.numberOfWeeksToScheduleJob;
    weeks = parseFloat(weeks);

    this.$events.setJobSchedule(this.jobble_id, weeks).then(
      (r) => {
        console.log("Updated job schedule:", r);

        this.$timeout(() => {
          this.closeLoadingModal();
        }, 1000);

        this.$timeout(() => {
          this.$rootScope.$emit("JobHasBeenScheduled", this.event);
          this.unSetLoader();
          this.savingStep = false;
          this.$state.go("jobsdashboard", {longTerm: "true"});
        }, 2500);
      },
      (error) => {
        console.error(error);
      }
    );
  }

  setAutomationForJob() {
    this.notifyJobblers();
    this.$timeout(() => {
      this.setSchedule();
    }, 1000);
  }

  notifyJobblers() {
    let teams_ids = this.event.cloudsForJobblePost;
    let payload;

    if (teams_ids && teams_ids.length > 0) {
      payload = {
        id: this.jobble_pool_id,
        visibility: "EXCLUSIVE",
      };
    } else {
      payload = {
        id: this.jobble_pool_id,
        visibility: "PUBLIC",
      };
    }

    if (!this.event.remote_job) {
      this.$events
        .notifyJobblers(payload)
        .then((data) => {
          console.log("Notified event:", data);
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }

  setLoader() {
    this.$timeout(() => {
      $("html").addClass("wait");
    });
  }

  unSetLoader() {
    this.$timeout(() => {
      $("html").removeClass("wait");
    });
  }

  validate() {
    //console.dir(e.keyCode);

    this.$rootScope.$emit(UPDATE_WORKFLOW_EVENT_NAME, {from_pay: true});

    if (!this.event || this.event.hourly_rate === undefined) return;

    const t = this.event.hourly_rate + "";

    this.event.hourly_rate = t.indexOf(".") >= 0 ? t.substr(0, t.indexOf(".")) + t.substr(t.indexOf("."), 3) : t;
    this.event.hourly_rate = parseFloat(this.event.hourly_rate);

    this.$rootScope.$emit(UPDATE_WORKFLOW_EVENT_NAME, {from_pay: true});

    //this.unSetLoader();
  }

  loadTeams() {
    let teamsSimple = [];
    let teams = [];
    this.$companies.getTeamsTrim().then(
      (data) => {
        try {
          data.data.forEach((team, index) => {
            team.firstLoadUsersCount = Math.min(team.users.length, 6);

            if (team.firstLoadUsersCount === 6) {
              team.firstLoadUsersCount = 5;
            }

            teams.push(team);

            let teamsObj = {};
            teamsObj.name = team.name;
            teamsObj.id = team.id;

            teamsSimple.push(teamsObj);
          });
        } finally {
          this.$timeout(() => {
            this.$rootScope.teams = teams;
            this.$rootScope.teamsSimple = teamsSimple;
            this.$rootScope.$emit("TeamsHaveLoaded", {
              teams: teams,
            });
          });
        }
      },
      (data) => {
        this.$rootScope.teams = [];
      }
    );
  }

  calculateCosts() {
    if (!this.event) return;
    if (!this.event.hourly_rate) return;

    const currentUser = this.$auth.getUserData();
    const rate = currentUser.company.defaultPlan.companyFeePct;
    const jobblerFeePct = currentUser.company.defaultPlan.companyFeePct;
    const pay = parseFloat(this.event.hourly_rate);
    const markUpCost = pay * (1 + rate) - pay;
    const epi = 0.00001;

    const cost = pay + markUpCost;
    const costRounded = pay + markUpCost;

    let companyPayRate = currentUser.company.defaultPlan.companyFeePct;
    companyPayRate = Math.round(companyPayRate * 100) / 100;

    if (this.event.shifts && this.event.shifts.length) {
      let hours = 0;

      this.event.shifts.forEach((shift) => {
        if (!shift) return;

        const startDate = new Date(`${shift.startDate} ${shift.startTime}`);
        const endDate = new Date(`${shift.endDate} ${shift.endTime}`);

        hours += (endDate.getTime() - startDate.getTime()) / 1000 / 60 / 60 - (shift.unpaidBreak ? shift.unpaidBreak : 0) / 60;
      });

      this.total_hours = hours;
      this.estimated_cost = Math.round((cost + epi) * 100 * hours * parseFloat(this.event.openings)) / 100;

      if (this.event.is_long_term && this.event.numberOfWeeksToScheduleJob && parseFloat(this.event.numberOfWeeksToScheduleJob) > 0) {
        this.estimated_total_cost = this.estimated_cost * (parseFloat(this.event.numberOfWeeksToScheduleJob) + 1);
        this.total_weeks = parseFloat(this.event.numberOfWeeksToScheduleJob) + 1;
      }

      this.platform_fee_cost = this.estimated_cost - Math.round((pay + epi) * 100 * hours * parseFloat(this.event.openings)) / 100;
      this.jobbler_payments = this.estimated_cost - this.platform_fee_cost;

      console.log(this.jobbler_payments, this.estimated_cost, this.estimated_total_cost, cost + epi);
    }
  }
}

PayrateController.$inject = [
  "$localStorage",
  "$rootScope",
  "$scope",
  "$state",
  "$stateParams",
  "auth",
  "env",
  "security",
  "$timeout",
  "$location",
  "tracking",
  "events",
  "companies",
];

export default PayrateController;



// WEBPACK FOOTER //
// ./client/app/scenes/postashiftwalkthrough/scenes/payrate/payrate.controller.js